module.exports = __webpack_public_path__ + "static/media/icon-total-bid.552a910c.svg";